var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPropertyMultiple = function SvgPropertyMultiple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    role: "presentation",
    focusable: "false"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.549 4 6.45 6.406-.705.71-5.745-5.707-2.472 2.455-.705-.71L15.55 4ZM8.45 5.934 2 12.34l.705.71 5.744-5.707 5.745 5.706.705-.71-6.45-6.405ZM4.848 14.08V19h7.203v-4.92h1V20H3.848v-5.92h1ZM19.16 12.135v4.921h-4.085v1h5.085v-5.92h-1Z",
    fill: "currentColor"
  })));
};
export default SvgPropertyMultiple;